import styles from "./HeaderBanner.module.scss";
import clsx from "clsx";

interface HeaderBannerProps {
  children: string;
  type?: "wood" | "card";
  className?: string;
}

const HeaderBanner = ({
  children,
  type = "wood",
  className,
}: HeaderBannerProps) => {
  return (
    <div
      className={clsx(
        styles.banner,
        type === "wood" && "wood-theme",
        type === "card" && styles.card,
        className
      )}
    >
      <h1 className={styles.title}>{children}</h1>
    </div>
  );
};

export default HeaderBanner;
